import AbstractService from "./AbstractService";


class SubDealerService extends AbstractService {

  static _getUrl(partUrl) {
    return `/rest/v1${partUrl}`;
  }

  static async getSubDealerProfile() {

    const url = this._getUrl(`/get-subdealer-profile`);

    return await this._getResource(url, undefined,
      {
        'public-request': 'true',
        'X-Forwarded-Host': window.location.hostname,
      }
    );
  }

}

export default SubDealerService;